'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _productSelector = require('./product-selector.scss');

var _productSelector2 = _interopRequireDefault(_productSelector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Shows a selector for the User to select a product
 *
 * (used for concepta-30 vs concepta-40)
 */
var ProductSelector = function (_React$Component) {
    _inherits(ProductSelector, _React$Component);

    function ProductSelector(props) {
        _classCallCheck(this, ProductSelector);

        var _this = _possibleConstructorReturn(this, (ProductSelector.__proto__ || Object.getPrototypeOf(ProductSelector)).call(this, props));

        _this.updateProduct = _this.updateProduct.bind(_this);
        return _this;
    }

    _createClass(ProductSelector, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var t = this.props.t;


            return _react2.default.createElement(
                'div',
                { className: _productSelector2.default["product-selector"] },
                _react2.default.createElement(
                    'p',
                    { className: 'color-red space-2' },
                    t('Two versions are possible for your weight class.'),
                    _react2.default.createElement('br', null),
                    t('Please choose:')
                ),
                _react2.default.createElement(
                    'div',
                    { className: _productSelector2.default.container },
                    _react2.default.createElement(
                        'label',
                        { className: _productSelector2.default.item, onClick: function onClick(e) {
                                return _this2.updateProduct(e, 'product30');
                            } },
                        _react2.default.createElement(
                            'span',
                            { className: _productSelector2.default["item-label"] },
                            _react2.default.createElement('input', { type: 'radio',
                                checked: this.props.product === 'product30' ? 'checked' : '',
                                value: 'product30',
                                onChange: function onChange(e) {} }),
                            t('HAWA-Concepta 30')
                        ),
                        _react2.default.createElement(
                            'span',
                            { className: _productSelector2.default["img-wrapper"] },
                            _react2.default.createElement('span', { style: { backgroundImage: 'url(/static/assets/images/c-30.png)' } })
                        ),
                        t('With top and bottom roller guide.')
                    ),
                    _react2.default.createElement(
                        'label',
                        { className: _productSelector2.default.item, onClick: function onClick(e) {
                                return _this2.updateProduct(e, 'product40');
                            } },
                        _react2.default.createElement(
                            'span',
                            { className: _productSelector2.default["item-label"] },
                            _react2.default.createElement('input', { type: 'radio',
                                checked: this.props.product === 'product40' ? 'checked' : '',
                                value: 'product40',
                                onChange: function onChange(e) {} }),
                            t('HAWA-Concepta 40')
                        ),
                        _react2.default.createElement(
                            'span',
                            { className: _productSelector2.default["img-wrapper"] },
                            _react2.default.createElement('span', { style: { backgroundImage: 'url(/static/assets/images/c-40.png)' } })
                        ),
                        t('With trolley at top and roller guide at bottom for quieter running.')
                    )
                )
            );
        }

        /**
         *
         * @param e
         * @param product
         */

    }, {
        key: 'updateProduct',
        value: function updateProduct(e, product) {
            e.preventDefault();

            this.props.updateProduct(product);
        }
    }]);

    return ProductSelector;
}(_react2.default.Component);

ProductSelector.propTypes = {
    updateProduct: _propTypes2.default.func.isRequired,
    t: _propTypes2.default.func.isRequired,
    product: _propTypes2.default.string
};

exports.default = ProductSelector;


//////////////////
// WEBPACK FOOTER
// ./client/components/product-selector/index.js
// module id = 496
// module chunks = 0